import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useList, useObject } from 'react-firebase-hooks/database';
import { Redirect, useHistory } from "react-router";
import "./Dashboard.css";
import { auth, db, logout, firebase_update, firebase_update_client_info} from "./firebase";

import Level from "./guages/level";
import Pressure from "./guages/pressure";
import Temp from "./guages/temp";
import Heat from "./guages/heat";
import GasLeak from "./guages/gasleak";
import Vaporizer from "./guages/vaporizer";

import Map from "./components/map";


import { useLocation } from 'react-router-dom';


import Grid from '@mui/material/Grid';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';

import { useMediaQuery } from 'react-responsive';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

import { green, red } from '@mui/material/colors';



import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import Divider from '@mui/material/Divider';

import { Form, Field } from 'react-final-form';


import ImageList from '@mui/material/ImageList';
import ImageListItem, { imageListItemClasses } from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import { Icon } from "@material-ui/core";



import DeviceStatus from "./DeviceStatus";
import { createTheme, ThemeProvider } from "@mui/material/styles";


function ClientDevices(props){
  const history = useHistory();

  const r = '/clients/' + props.uid;

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });

  const [client_snapshot, loading_client_snapshot, error_db] = useObject(db.ref(r));

  const [clientInfo, setClientInfo] = useState();
  const [clientDevices, setClientDevices] = useState([]);
  const [clientSharedDevices, setClientSharedDevices] = useState([]);
  const [clientStatus, setClientStatus] = useState();
  const [userRole, setUserRole] = useState();
  const [clientType, setClientType] = useState();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);


  useEffect(() => {
      if(client_snapshot && !loading_client_snapshot)
      {
        setClientInfo(client_snapshot.val().info);
        if(client_snapshot.child("devices").hasChildren())
        {
          var cd = [];
          var shared_cd = [];
          const objectArray = Object.entries(client_snapshot.val().devices);
          objectArray.forEach(([key, value]) => {
            var item = value;
            item.deviceId = key;
            if(item.shared == 'true')
            {
              shared_cd.push(item);
            }
            else
            {
              cd.push(item)
            }
          })
          setClientDevices(cd);
          setClientSharedDevices(shared_cd);
        }
        setClientStatus(client_snapshot.val()['status']);
        setClientType(client_snapshot.val().type);
        //console.log(clientDevices)
      }
  }, [client_snapshot, loading_client_snapshot]);

  if (loading_client_snapshot)
  {
    return (<div style={{alignItems: "center", display: 'flex', justifyContent: 'center', height: "100vh", width: "100vw" }}>
            <Box sx={{ display: 'flex' }}>
              <Typography variant="caption" style={{textAlign: "center"}} component="div" color="text.secondary">
                <CircularProgress /><br />
                Loading client devices...
              </Typography>
            </Box>
            </div>);
  }

const getFirstLetter = (str) => {
  return str.charAt(0);
}

const handleClickOpenEdit = () => {
  setOpenEdit(true);
};

const handleCloseEdit = () => {
  setOpenEdit(false);
};

const onSubmit = async values => {
  window.alert(JSON.stringify(values,0,2))
  firebase_update_client_info(props.uid, values);
  setOpenEdit(false);
}

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1600,
      xl: 1536
    }
  }
});
  

  return (
    <Box display="flex">       
        <Grid container>
            <Grid item xs={12}>
            {clientInfo ? (
            <Card style={{height: '100%'}}>
                <CardContent>
                    <Typography variant="h6" component="div">
                    {clientDevices ? (clientDevices.length + clientSharedDevices.length):(<div></div>)} LPG Devices
                    {clientInfo ? (<Typography>By {clientInfo.title}</Typography>) : (<div></div>)}
                    </Typography>
                    <Typography sx={{ mb: 1.5 }} color="text.secondary">
                    All device list for this client.
                    </Typography>
                    <Typography variant="body2">
                    All devices in the system from this client, both activated and not-yet-activated, is listing here. Each device can be viewed, edited, or deleted depend on authorization level.
                    </Typography>
                    <Grid container spacing={2} sx={{p: 2}}>
                        <Grid item xs={12}>
                        {(clientType == 'store') ? <div>
                        <Divider><Chip label={clientDevices.length + " Own Devices"}/></Divider>
                        <ThemeProvider theme={theme}>
                        <Box
                                    sx={{
                                      pt: 5,
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: "100%",
                                      display: "grid",
                                      gridTemplateColumns: {
                                        xs: "repeat(1, 1fr)",
                                        sm: "repeat(2, 1fr)",
                                        md: "repeat(4, 1fr)",
                                        lg: "repeat(6, 1fr)",
                                        xl: "repeate(7, 1fr)"
                                      },
                                      [`& .${imageListItemClasses.root}`]: {
                                        display: "flex",
                                        flexDirection: "column"
                                      }
                                    }}
                                  >  
                            { 
                                clientDevices && (
                                clientDevices.map((device) => (
                                    <ImageListItem key={device.deviceId} >
                                    {clientInfo ? (<div><DeviceStatus deviceId={device.deviceId} showTitle={true} scale={isTabletOrMobile ? 0.6 : 1} uid={props.uid} clientTitle={clientInfo.title} shared={device.shared} /></div>):(<div></div>)}
                                    </ImageListItem>)
                                ))
                                }
                            </Box>
                            </ThemeProvider>
                            <Divider><Chip label={clientSharedDevices.length + " Shared Devices"} /></Divider>
                            <ThemeProvider theme={theme}>
                            <Box
                                    sx={{
                                      pt: 5,
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: "100%",
                                      display: "grid",
                                      gridTemplateColumns: {
                                        xs: "repeat(1, 1fr)",
                                        sm: "repeat(2, 1fr)",
                                        md: "repeat(4, 1fr)",
                                        lg: "repeat(6, 1fr)",
                                        xl: "repeate(7, 1fr)"
                                      },
                                      [`& .${imageListItemClasses.root}`]: {
                                        display: "flex",
                                        flexDirection: "column"
                                      }
                                    }}
                                  >                                 
                              { 
                                clientSharedDevices && (
                                clientSharedDevices.map((device) => (
                                    <ImageListItem key={device.deviceId} >
                                    {clientInfo && (<div><DeviceStatus deviceId={device.deviceId} showTitle={true} scale={isTabletOrMobile ? 0.6 : 1} uid={props.uid} clientTitle={clientInfo.title} shared={device.shared} /></div>)}
                                    </ImageListItem>)
                                ))
                                }
                            </Box>
                            </ThemeProvider>
                            </div> : <div>                        
                            <Divider><Chip label={clientSharedDevices.length + " Shared Devices"} /></Divider>
                            <ThemeProvider theme={theme}>
                            <Box
                                    sx={{
                                      pt: 5,
                                      justifyContent: 'center',
                                      alignItems: 'center',
                                      height: "100%",
                                      display: "grid",
                                      gridTemplateColumns: {
                                        xs: "repeat(1, 1fr)",
                                        sm: "repeat(2, 1fr)",
                                        md: "repeat(4, 1fr)",
                                        lg: "repeat(6, 1fr)",
                                        xl: "repeate(7, 1fr)"
                                      },
                                      [`& .${imageListItemClasses.root}`]: {
                                        display: "flex",
                                        flexDirection: "column"
                                      }
                                    }}
                                  >                                 
                              { 
                                clientSharedDevices && (
                                clientSharedDevices.map((device) => (
                                    <ImageListItem key={device.deviceId} >
                                    {clientInfo && (<div><DeviceStatus deviceId={device.deviceId} showTitle={true} scale={isTabletOrMobile ? 0.6 : 1} uid={props.uid} clientTitle={clientInfo.title} shared={device.shared} /></div>)}
                                    </ImageListItem>)
                                ))
                                }
                            </Box>
                            </ThemeProvider>
                            </div>}
                            
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
                ):
                (<div></div>)}
                    </Grid>
                </Grid>
            </Box>
          );
}

export default ClientDevices;
